import { render, staticRenderFns } from "./DataPlansBanner.vue?vue&type=template&id=cf79b3da&"
import script from "./DataPlansBanner.vue?vue&type=script&lang=js&"
export * from "./DataPlansBanner.vue?vue&type=script&lang=js&"
import style0 from "./DataPlansBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports